import { useState, useEffect } from "react";

/**
 * Returns a counter that increments every time
 * window.dispatchEvent(new CustomEvent("analytics:refresh")) fires.
 * Add this to any hook's useEffect deps to auto-refetch after Run Now.
 */
export function useAnalyticsRefreshTrigger(): number {
  const [key, setKey] = useState(0);
  useEffect(() => {
    const handler = () => setKey(k => k + 1);
    window.addEventListener("analytics:refresh", handler);
    return () => window.removeEventListener("analytics:refresh", handler);
  }, []);
  return key;
}